import React, { useEffect, useState } from "react";
import Product from "./Product";
import { Box, CircularProgress, Grid } from "@mui/material";
import SortContext from "context/SortContext";
import { useFilter } from "context/FilterContext";
import { useGlobalContext } from "context/GlobalContext";
import RemoveProduct from "components/ui/RemoveModal/RemoveModal";
import Home from "pages/Home";
import { ReactComponent as Background } from "assets/icons/bg.svg";

import { useNavigate, useLocation, useParams } from "react-router-dom";
import { useQuery, useQueryClient } from "@tanstack/react-query";
import config from "configs/config";
import { useInView } from "react-intersection-observer";
import { useInfiniteQuery } from "@tanstack/react-query";
import { transformData, transformDataForTrayModal } from "utils/transformdata";
import ProductSkeleton from "components/ui/Skeleton/ProductSkeleton";
import apiClient from "lib/api-client";
import GoToTop from "components/ui/GoToTop";
import { usePermissions } from "context/PermissionsContext";
import { findSpecificMenu, findSpecificPage, findSpecificSubMenu, findSpecificSubPage, hasAccessPage, hasAccessSubPage, isAllowed } from "utils/checkUserRigths";
import { decodeStr, encodeStr, formatString } from "utils/encodeDecodeStr";
import { useCollectionDesigns } from "features/collection/hooks/useGetCollectionProducts";
import { toDayRangeISO } from "utils/dateRangeHelper";
import InfiniteScroll from "react-infinite-scroll-component";
import useGetAICollectionDesigns from "features/collection/hooks/useGetAICollectionDesigns";
import { getIcon } from "utils/iconsConfig";
import DataNotFound from "components/ui/datanotfound/DataNotFound";

function SubCollectionProduct() {
  console.log("Collection Parent====>>");
  const queryClient = useQueryClient(); // Initialize query client
  const { setSortOptions, setSelectedSortValue, search, setSearch, selectedSortValue, sortOptions, setIsEdit, isEdit } = React.useContext(SortContext);
  const permission = usePermissions();
  const { setRemoveIcon, setTrashModalOpen, trashModalOpen, setFilterChangeCount, setDisplayCount, setDynamicFilterCount, dynamicfilterCount, filterChangeCount, setSearchResultCount } =
    useGlobalContext();
  const { collectionName, subcategoryId } = useParams();

  const [checkedItems, setcheckedItems] = useState({});

  const [collectionId, setCollectionId] = useState("");
  const [collectionProductData, setCollectionProductData] = useState([]);
  const { ref, inView } = useInView();
  const navigate = useNavigate();
  const location = useLocation(); // Capture the current location
  const [previousPath, setPreviousPath] = useState(null); // Store previous path

  const selectedOption = sortOptions.find((option) => option.id == selectedSortValue);
  const selectedSortBY = selectedOption?.sortBy;
  const selectedSortOrder = selectedOption?.order;

  const { filterValues, setFilter, setFilterValues, setBackendFilterValues, setFilterCount, setAppliedFilterValues } = useFilter();
  const labourValues = filterValues && filterValues?.Labour?.map((item) => item.split(" - ")[0]).filter(Boolean);
  const classType = filterValues && filterValues?.Class;

  // Numeric range filters
  const diamondPieces = filterValues && filterValues["Diamond Pieces"]; // Access numeric ranges directly
  const diamondWeight = filterValues && filterValues["Diamond Weight"];
  const goldGrossWeight = filterValues && filterValues["Gold Gross-Weight"];
  const goldNetWeight = filterValues && filterValues["Gold Net-Weight"];
  const ratioRange = filterValues && filterValues["Ratio"];
  const designInCollection = filterValues && filterValues["Design In Collection"];
  const designInSets = filterValues && filterValues["Design In Sets"];
  const bestSeller = filterValues && filterValues["Best Seller Design"];
  const highestSeller = filterValues && filterValues["Highest Seller"];
  const stockStatus = filterValues && filterValues["Product Page Stock Status"];
  const isHidden = filterValues && filterValues["Show Hidden Designs"]; 
  // const hasAccessToSeeSales = hasAccessPage(findSpecificPage("Sales Count", permission), "view");

  const hasAccessToYearlySalesData = isAllowed(findSpecificSubMenu(findSpecificMenu("Vision Web", permission), "Sales By year"), "view");
  const hasAccessToClientSalesData = isAllowed(findSpecificSubMenu(findSpecificMenu("Vision Web", permission), "Sales By Client"), "view");
  const hasAccessToSeeSales = hasAccessToYearlySalesData || hasAccessToClientSalesData;
  // const hasAccessEditCollection = hasAccessPage(findSpecificPage("Collection", permission), "edit");
  const hasAccessEditCollection = isAllowed(findSpecificSubMenu(findSpecificMenu("Vision Web", permission), "Collection Access"), "view");
  let preState = location.state;
  const innerChnages = location?.state?.innerChnages;

  // Set the previous path on component mount
  useEffect(() => {
    if (location.pathname && location.pathname !== "/") {
      const segments = location.pathname.split("/");
      const parentPath = segments.slice(0, -1).join("/");
      setPreviousPath(parentPath || "/");
    }
    //for taking user to previous scrolled position
    if (location.state?.scrollPosition !== undefined) {
      window.scrollTo(0, location.state.scrollPosition);
    }
  }, [location]);

  useEffect(() => {
    return () => {
      // Clear query data on unmount
      queryClient.removeQueries("collectiondesigns", { exact: true });
    };
  }, [queryClient]);

  useEffect(() => {
    setFilter(true);
    if (innerChnages) {
      setIsEdit("");
    } else {
      let text = hasAccessEditCollection ? "view" : "";
      setIsEdit(text);
    }
    //---------------- Setting Sort Options --------------------\\
    setSortOptions([
      { id: 1, name: "Design No. (Low to High)", sortBy: "Design No", order: "asc" },
      { id: 2, name: "Design No. (High to Low)", sortBy: "Design No", order: "desc" },
      { id: 3, name: "Design Date (Oldest to Newest)", sortBy: "Design Date", order: "asc" },
      { id: 4, name: "Design Date (Newest to Oldest)", sortBy: "Design Date", order: "desc" },
      { id: 5, name: "Gold Net Weight (Low to High)", sortBy: "Gold Net Weight", order: "asc" },
      { id: 6, name: "Gold Net Weight (High to Low)", sortBy: "Gold Net Weight", order: "desc" },
      { id: 7, name: "Diamond Weight (Low to High)", sortBy: "Diamond Weight", order: "asc" },
      { id: 8, name: "Diamond Weight (High to Low)", sortBy: "Diamond Weight", order: "desc" },
      { id: 9, name: "Sales (Low to High)", sortBy: "Sales", order: "asc", access: hasAccessToSeeSales },
      { id: 10, name: "Sales (High to Low)", sortBy: "Sales", order: "desc", access: hasAccessToSeeSales },
      { id: 11, name: "Ratio (Low to High)", sortBy: "Ratio", order: "asc", access: true },
      { id: 12, name: "Ratio (High to Low)", sortBy: "Ratio", order: "desc", access: true },
    ]);
    //---------------- Filter Slider API --------------------\\

    const fetchFilterData = async () => {
      try {
        const response = await apiClient.post(`${config.baseUrl}/api/v1/collection/getDesignSlidersData`, {
          collectionName: location.state.name[0],
          collectionCatgeoryName: location.state.name[1].split("-")[0].trim(),
        });

        if (response.data && response.data.data) {
          const { diamondPieces, diamondWeight, grossWeight, netWeight, ratio } = response.data.data;
          let filterData = {
            Labour: ["R", "X", "X2", "X5", "X8", "XX"],
            Class: ["Gold", "Silver", "Bronze", "Under Ratio"],
            "Design In Collection": ["All"],
            "Design In Sets": ["All"],
            "Ratio": ratio || [],
            "Diamond Pieces": diamondPieces || [],
            "Diamond Weight": diamondWeight || [],
            "Gold Gross-Weight": grossWeight || [],
            "Gold Net-Weight": netWeight || [],
            "Highest Seller": [],
            "Best Seller Design": ["All"],
            "Product Page Stock Status": ["All"],
            "Design Create Date": [],
            "Show Hidden Designs":false
          };
          let backendOptions = { ...filterData };
          delete backendOptions["Design In Collection"];
          delete backendOptions["Design In Sets"];
          delete backendOptions["Product Page Stock Status"];
          // Update the state with the fetched data
          setBackendFilterValues(backendOptions);
          setFilterValues(filterData);

          if (sessionStorage.getItem("filterChangeCount") == 0) {
            setFilterValues(filterData);
          } else {
            setFilterValues(JSON.parse(sessionStorage.getItem("appliedFilterValues")));
          }
        }
      } catch (error) {
        console.error("Error fetching filter data:", error);
      }
    };

    fetchFilterData();

    return () => {
      setFilter(false);
      setIsEdit("");
      setSearch("");
      setSortOptions([]);
      setSelectedSortValue(null);
      setFilterValues({
        Labour: [],
        Class: [],
        "Diamond Pieces": [],
        "Diamond Weight": [],
        "Gold Gross-Weight": [],
        "Gold Net-Weight": [],
        "Design In Collection": [],
        "Design In Sets": [],
        "Highest Seller": [],
        "Best Seller Design": [],
        "Product Page Stock Status": [],
      });
      setCollectionProductData([]);
      setAppliedFilterValues({});
      setFilterCount(0);
      sessionStorage.setItem("filterChangeCount", 0);
      sessionStorage.removeItem("appliedSortValue");
    };
  }, []);

  useEffect(() => {
    sessionStorage.setItem("appliedSortValue", selectedSortValue);
  }, [selectedSortValue, sortOptions]);

  // for handling the delete(edit) desing in the collection flow
  useEffect(() => {
    if (isEdit === "click") {
      setSortOptions([]);
      setFilter(false);
    } else {
      setSortOptions([
        { id: 1, name: "Design No. (Low to High)", sortBy: "Design No", order: "asc" },
        { id: 2, name: "Design No. (High to Low)", sortBy: "Design No", order: "desc" },
        { id: 3, name: "Design Date (Oldest to Newest)", sortBy: "Design Date", order: "asc" },
        { id: 4, name: "Design Date (Newest to Oldest)", sortBy: "Design Date", order: "desc" },
        { id: 5, name: "Gold Net Weight (Low to High)", sortBy: "Gold Net Weight", order: "asc" },
        { id: 6, name: "Gold Net Weight (High to Low)", sortBy: "Gold Net Weight", order: "desc" },
        { id: 7, name: "Diamond Weight (Low to High)", sortBy: "Diamond Weight", order: "asc" },
        { id: 8, name: "Diamond Weight (High to Low)", sortBy: "Diamond Weight", order: "desc" },
        { id: 9, name: "Sales (Low to High)", sortBy: "Sales", order: "asc", access: hasAccessToSeeSales },
        { id: 10, name: "Sales (High to Low)", sortBy: "Sales", order: "desc", access: hasAccessToSeeSales },
        { id: 11, name: "Ratio (Low to High)", sortBy: "Ratio", order: "asc", access: true },
        { id: 12, name: "Ratio (High to Low)", sortBy: "Ratio", order: "desc", access: true },
      ]);
      setFilter(true);
    }
  }, [isEdit]);

  //----------------- API Integration  ----------------\\
  let collectionNameIs = collectionName;
  let categoryNameIs = subcategoryId.split("-")[0];

  let payloadForNormalApi = {
    limit: 30,
    sortBy: selectedSortBY,
    order: selectedSortOrder,
    searchTerm: search,
    labourFilter: labourValues?.length > 0 ? labourValues : "",
    classFilter: classType?.length > 0 ? classType : "",
    diamondPieces: diamondPieces?.length > 0 ? diamondPieces : "",
    diamondWeight: diamondWeight?.length > 0 ? diamondWeight : "",
    goldGrossWeight: goldGrossWeight?.length > 0 ? goldGrossWeight : "",
    goldNetWeight: goldNetWeight?.length > 0 ? goldNetWeight : "",
    ratioRange: ratioRange?.length > 0 ? ratioRange : "",
    designInCollection: designInCollection?.length > 0 ? designInCollection : "",
    designInSets: designInSets?.length > 0 ? designInSets : "",
    collectionName: collectionNameIs,
    categoryName: categoryNameIs,
    bestSeller: bestSeller && bestSeller[0] === "No" ? "NO" : bestSeller && bestSeller[0] === "Yes" ? "YES" : "",
    highestSeller: highestSeller && highestSeller?.length > 0 ? highestSeller : "",
    stockStatus: stockStatus && stockStatus[0],
    designCreateDate: toDayRangeISO(filterValues?.["Design Create Date"]),
    isHidden:!isHidden,
  };

  const { data, fetchNextPage, hasNextPage, isFetchingNextPage, isLoading, isError, error, refetch } = useCollectionDesigns(payloadForNormalApi);

  useEffect(() => {
    if (data) {
      const allProducts = data.pages.flatMap((page) => page.data);
      setCollectionProductData(allProducts);
    }
  }, [data]);

  // useEffect(() => {
  //   setFilterChangeCount(data?.pages[0]?.totalCount); //totalCount
  //   setDisplayCount(true);
  //   return () => {
  //     setFilterChangeCount(0);
  //     setDisplayCount(false);
  //   };
  // }, [data]);

  useEffect(() => {
    if (search === "") {
      setDynamicFilterCount(true);
    }
    if (dynamicfilterCount) {
      setFilterChangeCount(data?.pages[0]?.totalCount);
      setSearchResultCount(data?.pages[0]?.totalCount);
    } else {
      setSearchResultCount(data?.pages[0]?.totalCount);
      setFilterChangeCount(filterChangeCount);
    }
    setDisplayCount(true);
    return () => {
      setSearchResultCount(0);
      setFilterChangeCount(0);
      setDisplayCount(false);
    };
  }, [data]);

  //----------- When user Copy Paste URL -------------------\\
  useEffect(() => {
    const decodedCollectionName = decodeURIComponent(collectionName);
    let collectionCatgeoryName = decodeURIComponent(subcategoryId).split("-")[0];

    if (!location.state?.name) {
      navigate(location.pathname, { state: { name: [decodedCollectionName, `${collectionCatgeoryName}`] }, replace: true });
    }
  }, []);

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, [selectedSortValue, filterValues, search]);

  //------------------------------------------------------\\

  const handleCheckboxChange = (itemId) => (event) => {
    setcheckedItems((prevCheckedItems) => {
      const newCheckedItems = { ...prevCheckedItems };

      if (event.target.checked) {
        newCheckedItems[itemId] = true;
      } else {
        delete newCheckedItems[itemId];
      }

      return newCheckedItems;
    });
  };

  const btnInfo = [
    {
      btnName: "Remove",
      bgColor: "#E77B7B",
      click: async () => {
        const removedItems = JSON.parse(sessionStorage.getItem("RemoveCollectionDesign"));
        const findRemoveProductIds = removedItems.map((item) => item._id);
        const currentScrollPosition = window.scrollY;
        const payload = {
          collectionId: JSON.parse(sessionStorage.getItem("collectionIdOfProducts")),
          styleRefIds: findRemoveProductIds,
        };

        const removeDesignResponse = await apiClient.post(`${config.baseUrl}/api/v1/collection/removeDesign`, payload);

        if (removeDesignResponse.status === 200) {
          // Update local state immediately WITHOUT refetch
          setCollectionProductData((prev) => prev.filter((product) => !findRemoveProductIds.includes(product._id)));

          // Update counts immediately
          const currentCount = data?.pages[0]?.totalCount || 0;
          const newCount = Math.max(0, currentCount - findRemoveProductIds.length);

          setFilterChangeCount(newCount);
          setSearchResultCount(newCount);

          let currentPage = location.state.name[location.state.name.length - 1];

          if (removeDesignResponse.data.updatedCollection.numberOfStyles === 0) {
            navigate("/Collection");
          } else {
            let getCategories = removeDesignResponse.data.updatedCollection.categories;
            let totalCount = getCategories.reduce((acc, cat) => {
              return acc + cat.count;
            }, 0);
            let currentPageName = currentPage.split("-");
            currentPageName = currentPageName[0].split(" ");
            let findCurrentPageDesignCount;
            if (currentPageName[0] === "All") {
              findCurrentPageDesignCount = {
                categoryName: "All",
                count: totalCount,
              };
            } else {
              findCurrentPageDesignCount = getCategories.find((cat) => {
                if (cat.categoryName === currentPageName[0]) {
                  return cat.count;
                }
              });
            }

            if (!(findCurrentPageDesignCount?.count > 0)) {
              const currentPreState = { ...preState, name: [...preState.name] };

              navigate(previousPath || "/Collection", { state: currentPreState });
            } else {
              const updatedState = {
                ...location.state,
                name: [`${location.state.name[0]}`, `${currentPage.split(" - ")[0]}`],
                // name: [`${location.state.name[0]}`, `${currentPage.split(" - ")[0]} - ${findCurrentPageDesignCount?.count || 0}`],
                scrollPosition: currentScrollPosition,
              };

              // Navigate to the same path with the updated state for showing updated count
              navigate(location.pathname, { state: updatedState });
            }
          }

          setTrashModalOpen(false);
          setcheckedItems({});
          sessionStorage.removeItem("RemoveCollectionDesign");
          queryClient.invalidateQueries({ queryKey: ["collectiondesigns"] });
        } else {
          alert(removeDesignResponse.message);
        }
      },
    },
    {
      btnName: "Keep",
      bgColor: "#50C878",
      click: () => {
        setTrashModalOpen(false);
        setcheckedItems({});
      },
    },
  ];

  useEffect(() => {
    if (Object.keys(checkedItems).length > 0) {
      setRemoveIcon(true);
    } else {
      setRemoveIcon(false);
    }
    return () => setRemoveIcon(false);
  }, [checkedItems]);

  if (isError) return <div>Error: {error.message}</div>;

  if (isLoading) return <ProductSkeleton count={10} />;

  const hasNoResults =
    search &&
    data?.pages?.every(
      (page) => !page?.data?.length
    );

  if (hasNoResults) return <DataNotFound message={`No results found for "${search}"`} />;

  return (
    <>
      <InfiniteScroll
        dataLength={data?.pages.flatMap((page) => page.data).length || 0} // Total items loaded
        next={fetchNextPage} // Fetch the next page of designs
        hasMore={!!hasNextPage} // Whether there are more pages to load
        loader={isFetchingNextPage && <CircularProgress sx={{ display: "flex", justifyContent: "center", margin: "20px auto" }} />}
        scrollThreshold={0.8} // Trigger next page when 80% scrolled
        endMessage={<p style={{ textAlign: "center" }}>You have seen it all!</p>}
      >
        <Grid
          container
          direction="row"
          justifyContent="flex-start"
          sx={{ flex: "1 1 1", display: "flex", alignItems: "center", justifyContent: "flex-start", gap: "30px", rowGap: "32px" }}
          className="Grid-padding"
          rowGap={"16px"}
        >
          {collectionProductData?.map((product, ind) => {
            return (
              <Product
                product={transformDataForTrayModal(product)}
                index={ind}
                key={product._id}
                handleCheckboxChange={handleCheckboxChange}
                checkedItems={checkedItems}
                allData={collectionProductData}
              />
            );
          })}
          <RemoveProduct
            open={trashModalOpen}
            setOpen={setTrashModalOpen}
            btnInfo={btnInfo}
            heading={`Remove ${JSON.parse(sessionStorage.getItem("RemoveCollectionDesign"))?.length} selected designs from Collection?`}
          />
        </Grid>
      </InfiniteScroll>

      <GoToTop />

      {data?.pages?.length === 0 ||
        (!data?.pages.some((page) => page?.data?.length > 0) && (
          <div
            style={{
              display: "flex",
              textAlign: "center",
              margin: "auto",
              padding: "auto",
              justifyContent: "center",
              alignItems: "center",
              height: "78vh",
            }}
          >
            <Background />
          </div>
        ))}
    </>
  );
}

export default SubCollectionProduct;
